var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pc-row"},_vm._l((_vm.pc),function(col,i){return _c('pc-col',{key:i,attrs:{"col":col}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }